import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sinceLabel',
    standalone: true,
})
export class SinceLabelPipe implements PipeTransform {
    transform(pastDate: Date): string {
        const currentDate = new Date();
        const hours = Math.floor(Math.abs(currentDate.getTime() - pastDate.getTime()) / 36e5);

        if (hours > 24) {
            return Math.floor(hours / 24) + ' jours';
        }

        return hours + ' heures';
    }
}
